import { cn } from '@/lib/utils';
import { Card, CardContent } from '@/components/ui/card';

/**
 * KPI card in the design prototype's `.kpi` shape: left-aligned mono
 * uppercase micro-label, a large tabular value, and a small delta line that
 * turns destructive when the movement is bad. (Previously centered with a
 * value-first stack — the prototype reads label-first, left-aligned.)
 */
interface KPICardProps {
  value: string;
  label: string;
  delta?: string;
  deltaType?: 'positive' | 'negative' | 'neutral';
}

export default function KPICard({ value, label, delta, deltaType = 'neutral' }: KPICardProps) {
  return (
    <Card size="sm" className="min-w-0 flex-1">
      <CardContent className="px-4 py-1">
        <div className="font-mono text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
          {label}
        </div>
        <div className="mt-2 text-[26px] font-bold leading-none tracking-[-0.025em] tabular-nums text-foreground">
          {value}
        </div>
        <div
          className={cn(
            'mt-1.5 min-h-4 text-[11.5px]',
            deltaType === 'positive' && 'text-success',
            deltaType === 'negative' && 'text-destructive',
            deltaType === 'neutral' && 'text-muted-foreground',
          )}
        >
          {delta ?? ''}
        </div>
      </CardContent>
    </Card>
  );
}
